import React, { useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import parse from 'html-react-parser'
import Pagination from '../../pages/paginations'
import { Add } from './Add'
import { Edit } from './Edit'
import { TanggalHari } from '../../Utils'
import axiosJWT from '../../JwtToken'

function View() {
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)
    
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])
    const [add, setAdd] = useState(false)
    const [rowID, setRowID] = useState(false)
    const [edit, setEdit] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        getData('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async (key) => {
        try {
            const response = await axiosJWT.post("/api/meeting/user", {
                key: key
            })
            setData(response.data)
            setCurrentPage(1)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Data tidak terkirim, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const proses = async (id) => {
        try {
            const hapus = await axiosJWT.delete(`/api/meeting/${id}`)
            getPesan()
            setMsg(hapus.data.msg)
            setTimeout(() => {
                getData()
            }, 1000)
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Data tidak terkirim, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    const getPesan = () => {
        setPesan((prevState) => !prevState)
    }

    const display = {
        display: `${pesan ? "block" : "none"}`,
    }

    const openAdd = async () => {
        getAdd()
    }

    const closeAdd = () => {
        getAdd()
    }

    const getAdd = () => {
        setAdd((prevState) => !prevState)
    }

    const displayAdd = {
        display: `${add ? "block" : "none"}`
    }

    const openEdit = async (id) => {
        setRowID(id)
        getEdit()
    }

    const closeEdit = () => {
        setRowID(null)
        getEdit()
    }

    const getEdit = () => {
        setEdit((prevState) => !prevState)
    }

    const displayEdit = {
        display: `${edit ? "block" : "none"}`
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-4">
                                <button onClick={openAdd} className="btn btn btn-raised btn-primary br-2 no-m">
                                    <i className="fa fa-plus"></i> Tambah
                                </button>
                            </div>
                            <div className="col-md-10 col-xs-8">
                                <input type="text" className="form-control" placeholder="Masukkan Kata Kunci" onChange={(e) => getData(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-nomargin dataTable table-bordered data">
                            <thead>
                                <tr className="purple">
                                    <th>No</th>
                                    <th>Kd. Permohonan</th>
                                    <th>Maksud & Tujuan</th>
                                    <th>Informasi Janjian</th>
                                    <th>Status</th>
                                    <th>Proses</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((row, i) => (
                                    <tr key={row._id}>
                                        <td width={"5%"}>{i + 1}</td>
                                        <td width={"12%"}>{row.code}</td>
                                        <td width={"23%"} className="text-left">{parse(row.description)}</td>
                                        <td width={"35%"} className="text-left">
                                            <h5 className="mt-0 mb-1">Informasi Tujuan</h5>
                                            Nama: <span className="badge d-inline-block text-wrap badge-success">{row.destination_agency}</span><br></br>
                                            Alamat: <span className="badge d-inline-block text-wrap badge-success">{row.destination_address}</span><br></br>
                                            Kontak: <span className="badge d-inline-block text-wrap badge-success">{row.destination_contact}</span><br></br>
                                            Telepon: <span className="badge d-inline-block text-wrap badge-success">{row.destination_phone}</span><br></br>
                                            Email: <span className="badge d-inline-block text-wrap badge-success">{row.destination_email}</span><br></br>
                                            <h5 className="mb-1">Informasi Janjian</h5>
                                            {row.type === '1' ? <span className="badge d-inline-block text-wrap badge-danger">Offline</span> : <span className="badge d-inline-block text-wrap badge-info">Online</span>}
                                            <br></br>
                                            {row.type === '1' ? 
                                                (<>Lokasi: <span className="badge d-inline-block text-wrap badge-success">{row.location}</span></>) : (<>
                                                Meeting Media: <span className="badge d-inline-block text-wrap badge-success">{row.location}</span><br></br>
                                                Meeting ID: <span className="badge d-inline-block text-wrap badge-success">{row.meeting_id}</span><br></br>
                                                Meeting Password: <span className="badge d-inline-block text-wrap badge-success">{row.meeting_password}</span><br></br>
                                                Meeting Access: <a rel="noopener noreferrer" target="_blank" href={row.meeting_access} className="badge badge-primary">Klik Disini</a>
                                            </>)}
                                            <br></br>
                                            Tanggal: <span className="badge d-inline-block text-wrap badge-success"><TanggalHari value={row.datetime.substr(0, 10)}/></span>
                                            <br></br>
                                            Waktu: <span className="badge d-inline-block text-wrap badge-success">{row.datetime.substr(11, 5)} WIB</span>
                                        </td>
                                        <td width={"20%"} className="text-left">
                                            Status:&nbsp;
                                            {row.status === '0' ? <span className="badge d-inline-block text-wrap badge-success">Verifikasi</span> : ''}
                                            {row.status === '1' ? <span className="badge d-inline-block text-wrap badge-warning">Pending (Lihat Keterangan)</span> : ''}
                                            {row.status === '2' ? <span className="badge d-inline-block text-wrap badge-info">Konfirmasi Instansi Tujuan</span> : ''}
                                            {row.status === '3' ? <span className="badge d-inline-block text-wrap badge-primary">Disetujui</span> : ''}
                                            {row.information && row.information !== 'undefined' ? parse(row.information) : null}
                                        </td>
                                        <td width={"5%"} className="text-center">
                                            {row.status === '0' || row.status === '1' ? (<>
                                                <button onClick={() => openEdit(row._id)} className="btn btn-raised btn-success br-2 no-m">
                                                    <i className="fa fa-pencil no-m"></i>
                                                </button>
                                            </>) : null}
                                            {row.status === '0' ? (<>
                                                <button onClick={() => proses(row._id)} className="btn btn-raised btn-danger br-2 mt-1">
                                                    <i className="fa fa-trash no-m"></i>
                                                </button>
                                            </>) : null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-6">
                                Ditemukan <b>{data.length}</b> Data
                            </div>
                            <div className="col-md-10 col-xs-6">
                                <Pagination className="pagination-bar text-right" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-xs-12">
                            <b>Catatan:</b>
                            <span className="badge d-inline-block text-wrap badge-danger ml-1">Pastikan kembali data yang dikirim, Status Janjian yang telah AKTIF tidak dapat di EDIT dan di HAPUS. Terima kasih.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {add ? (<>
            <div className={add ? ("modal-open") : ("")}>
                <div style={displayAdd} className={add ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">Tambah Janjian</h4>
                            </div>
                            <div className="modal-body">
                                <Add getData={getData} closeAdd={closeAdd} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}
        {edit ? (<>
            <div className={edit ? ("modal-open") : ("")}>
                <div style={displayEdit} className={edit ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">Edit Janjian</h4>
                            </div>
                            <div className="modal-body">
                                <Edit getData={getData} rowID={rowID} closeEdit={closeEdit} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}
        <div className={pesan ? "modal-open" : ""}>
            <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                PESAN
                            </h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}

export default View